const {Component}        = require("react");
const PriceSelector      = require("app/components/products/configuration/PriceSelector");
const checkout           = require("app/pipelines/checkout/products");
const env                = require("app/services/env");
const PropTypes          = require("prop-types");
const debounce           = require("app/util/debounce");
const TextCardSelector   = require("app/components/products/configuration/TextCardSelector");
const RibbonSelector     = require("app/components/products/configuration/RibbonSelector");
const ColorSelector      = require("app/components/products/configuration/ColorSelector");
const manager            = require("app/pipelines/checkout/manager");
const googleAnalytics    = require('app/services/googleAnalytics');
const { trackAddToCart } = require('../../../services/tracking')
const Trans              = require('app/components/trans/Trans')

class ConfigurationWidget extends Component {

	static get propTypes() {
		return {
			id: PropTypes.number.isRequired,
			type: PropTypes.string.isRequired,
			price: PropTypes.object.isRequired,
			available: PropTypes.bool.isRequired,
			hasCard: PropTypes.bool.isRequired,
			salesColors: PropTypes.array
		};
	}

	componentDidMount() {
		checkout.change.pipe(payload => {
			this.forceUpdate();
			return payload;
		});
	}

	get cart() {
		return env.get("checkout.cart.products");
	}

	addToCart = debounce(250, () => {
		let payload = {
			product_id: this.props.id,
			price: this.priceSelector.value
		};

		// Color
		if (this.colorSelector) {
			payload.color = this.colorSelector.value;
		}

		// Card
		if (this.props.hasCard && this.textCardSelector) {
			const cardValue = this.textCardSelector.value;

			payload.card_type = cardValue.type;
			payload.card_message = cardValue.text;
		}

		// Ribbon
		if ((this.props.type === "funeral") && this.ribbonSelector) {
			const ribbonValue = this.ribbonSelector.value;

			if (ribbonValue) {
				payload.ribbon_id = ribbonValue.id;
				payload.ribbon_messages = ribbonValue.messages;
			}
		}

		checkout.add.request.dispatch(payload).then((payload) => {
			// Old
			if(!env.debug()){
				googleAnalytics('config', 'UA-5570334-3', {
                  'page_title': translate('Læg i kurven'),
                  'page_path': translate('/læg-i-kurv'),
				});
			}

			if (payload.items.length > 0) {
				trackAddToCart(payload)
			}

			manager.open.dispatch({cart: "product"});
		});
	});

	_onAddToCart = (e) => {
		e.preventDefault();
		this.addToCart();
	};

	renderUnavailable() {
		return (
			<div className="state state-unavailable">
				<div className="state-title"><Trans>Bemærk venligst</Trans></div>
				<p><Trans>Produktet kan ikke købes i øjeblikket, da produktet hovedsageligt indeholder blomster, som er uden for
					sæson.</Trans></p>
				<p><Trans>Få mere information om sæsonen for det enkelte produkt i produktbeskrivelsen.</Trans></p>
			</div>
		);
	}

	renderIncompatibleFuneral() {
		return (
			<div className="state state-incompatible">
				<div className="state-title"><Trans>Bemærk venligst</Trans></div>
				<p><Trans>Da du allerede har lagt et eller flere begravelses-produkter i din indkøbskurv, kan du ikke bestille dette
					produkt på samme ordre.</Trans></p>
				<p><Trans>Færdiggør i stedet ordren med din nuværende indkøbskurv. Derefter er du velkommen til at bestille en ny
					ordre.</Trans></p>
			</div>
		);
	}

	renderIncompatibleRegular() {
		return (
			<div className="state state-incompatible">
				<div className="state-title"><Trans>Bemærk venligst</Trans></div>
				<p><Trans>Da du allerede har lagt et eller flere produkter i din indkøbskurv, kan du ikke bestille dette
					begravelses-produkt på samme ordre.</Trans></p>
				<p><Trans>Færdiggør i stedet ordren med din nuværende indkøbskurv. Derefter er du velkommen til at bestille en ny
					ordre.</Trans></p>
			</div>
		);
	}

	renderUnfinished() {
		return (
			<div className="state state-unfinished">
				<div className="state-title"><Trans>Afventer betaling</Trans></div>
				<p><Trans>Du skal udfylde eller tilbagekalde din nuværende vogn, inden du bestiller en ny ordre.</Trans></p>
			</div>
		);
	}

	renderTextCard() {
		if (this.props.hasCard) {
			return (<TextCardSelector ref={el => this.textCardSelector = el}/>)
		}
	}

	renderRibbonSelector() {
		if (this.props.type === "funeral") {
			return (<RibbonSelector ref={el => this.ribbonSelector = el}/>)
		}
	}

	renderColorSelector() {
		if (this.props.salesColors && (Object.keys(this.props.salesColors).length > 0)) {
			return (<ColorSelector ref={el => this.colorSelector = el} options={this.props.salesColors}/>)
		}
	}

	renderConfigurator() {
		return (
			<div className="configurator-body">
				<PriceSelector ref={el => this.priceSelector = el} {...this.props.price}/>
				{this.renderColorSelector()}
				{this.renderTextCard()}
				{this.renderRibbonSelector()}
				<div className="actions">
					<button onClick={this._onAddToCart} className="btn primary"><Trans>LÆG I KURVEN</Trans></button>
				</div>
			</div>
		);
	}

	renderBody() {
		if (this.props.available === false) {
			return this.renderUnavailable();
		}

		const cartType = env.get("checkout.cart.products.productType");

		if (cartType && (this.props.type !== cartType)) {
			return cartType === "regular" ?
				this.renderIncompatibleRegular() :
				this.renderIncompatibleFuneral();
		}

		return this.renderConfigurator();
	}

	render() {
		return (
			<div className="product-configurator">{this.renderBody()}</div>
		);
	}

}

module.exports = ConfigurationWidget;
